<template>
	<div>
		<div class="feedaty_widget_line" :id="'feedaty_widget_line-' + uid" v-if="isSmall"></div>
		<div id="feedaty_widget_big" v-if="isBig"></div>

		<div id="feedaty_google" v-html="zoorateGoogle" v-if="isBig"></div>
	</div>
</template>

<script>
import Vue from 'vue'
import { dates } from '../mixins/dates'

const moment = require('moment')

export default {
	props: {
		isSmall: {
			type: Boolean,
			default: false
		},
		isBig: {
			type: Boolean,
			default: false
		},
		uid: {
			type: Number,
			default: null
		}
	},

	data () {
		return {
			zoorateGoogle: null
		}
	},

	mixins: [dates],

	methods: {
		feedaty () {
			var divId = ''

			if (this.isSmall) divId = 'feedaty_widget_line-' + this.uid
			if (this.isBig) divId = 'feedaty_widget_big'

			var zoorateParams = {
				'zoorate_site_key': 'b170b1bd1a8210950f535b847b4b542e',
				'zoorate_widget_css': '',
				'zoorate_widget_type': '',
				'zoorate_widget_id': 'cc3b50a80ec8d2a4' + '|' + document.URL,
				'zoorate_widget_server': 'widget.zoorate.com',
				'zoorate_div_id': divId
			}

			window.zoorate_global_obj = {}

			if (typeof do_widget === 'function') {
				do_widget(zoorateParams)
			}

			if (this.isBig) {
				var data = localStorage.getItem('zoorate')

				if (data) {
					var now = moment()
					var expiration = moment(JSON.parse(data).timestamp).add(1, 'd')
					var expired = moment(expiration).isBefore(moment(now))

					if (!expired) {
						this.zoorateGoogle = JSON.parse(data).content
						return
					}
				}

				return this.call_zoorate().then(response => {
					this.zoorateGoogle = response.body
					localStorage.setItem('zoorate', JSON.stringify({
						timestamp: moment(),
						content: this.zoorateGoogle
					}))
				}).catch(response => {
					
				})
			}
		},

		call_zoorate () {
			var url = process.env.VUE_APP_API_URL
			return Vue.http.get(url + '/zoorate')
		}

	},

	mounted () {
		this.feedaty()
	}

}

</script>

<style>
#feedaty_google {
	font-size: 12px;
	color: grey;
	margin-top: 0;
}

#feedaty_google p {
	margin-bottom: 0;
}
</style>
